import * as THREE from 'three'
import Experience from "../../Experience"
import Ring from './ring'
export default class Casino {
    constructor() {
        this.experience = new Experience()

        // console.log(this.experience.ressources.items.casinoBoard);
        // console.log(this.experience.ressources.items.casinoRing);

        this.shaderMaterial1 = new THREE.MeshStandardMaterial({ color: 'white', side: THREE.DoubleSide, metalness: 1, roughness: 0.3 })
        this.shaderMaterial2 = new THREE.MeshStandardMaterial({ color: 'red', side: THREE.DoubleSide, metalness: 1, roughness: 0.3 })



        // start building
        this.init()
        this.isPlaying = true
        this.life = 3


    }

    init() {
        // envmap
        // this.envMap = this.experience.ressources.items.envMap
        // this.envMap.mapping = THREE.EquirectangularReflectionMapping
        // this.experience.scene.environment = this.envMap
        //    Geometries
        this.setScene()
        this.setLights()
        this.experience.debug.ui ? this.setDebug() : null
        this.setMouse()





    }
    setScene() {
        this.gameScene = this.experience.ressources.items.gameScene.scene
        // NOMMER LA SCENE
        this.gameScene.traverse((el) => {
            el.name === 'fond' ? this.background = el : null
            el.name === 'borders' ? this.borders = el : null
            el.name === 'Plane' ? this.plane = el : null
            el.name === 'outerRings' ? this.outerRings = el : null
            el.name === 'Circle' ? this.circle = el : null
            el.name === 'shaderPlane1' ? this.shaderPlane1 = el : null
            el.name === 'shaderPlane2' ? this.shaderPlane2 = el : null


        })

        // SCALE LE BACKGROUND EN FULL SCREEN
        this.background.scale.set(Math.tan((this.experience.camera.instance.fov * Math.PI) / 360) * 11 * this.experience.camera.instance.aspect, 1, Math.tan((this.experience.camera.instance.fov * Math.PI) / 360) * 11)
        // CREER LES GROUPES
        this.board = new THREE.Group()

        this.board.add(this.borders, this.plane, this.outerRings)
        this.experience.scene.add(this.background)
        this.experience.scene.add(this.board)

        // rings
        this.ring = new THREE.Group()
        this.ring.add(this.circle, this.shaderPlane1, this.shaderPlane2)
        // 
        this.rings = []


        // this.test = new Ring({ x: 0 * 0.9 - 0.9, y: 0 * 0.9 - 0.9, z: 0 }, this.ring, this.board, this.experience.ressources.items.logo, true, 1)

        for (let i = 0; i < 3; i++) {
            for (let j = 0; j < 3; j++) {
                const id = i * 3 + j;
                const ring = new Ring({ x: i * 0.9 - 0.9, y: j * 0.9 - 0.9, z: 0 }, this.ring, this.board, this.experience.ressources.items.logo, false, id)
                this.rings.push(ring)
            }
        }
        // générer 3 jetons gagnants
        const uniqueIndices = new Set();
        while (uniqueIndices.size < 3) {
            const randIndex = Math.floor(Math.random() * 9);
            uniqueIndices.add(randIndex);
        }
        const [randIndex1, randIndex2, randIndex3] = [...uniqueIndices];
        this.rings[randIndex1].setWin(true);
        this.rings[randIndex2].setWin(true);
        this.rings[randIndex3].setWin(true);

    }
    setLights() {
        this.ambientLight = new THREE.AmbientLight('#ffffff', 1)
        // 
        this.directionnalLight = new THREE.DirectionalLight('#ffffff', 1)
        this.directionnalLight.position.set(2, 2, 2)
        // this.directionnalLight.position.set(0.5, 0.5, 2)
        this.dirHelper = new THREE.DirectionalLightHelper(this.directionnalLight, 1, '#ff0000')
        // 
        this.pointLight = new THREE.PointLight('#ffffff', 1.5)
        this.pointLight.position.set(-0.5, 0.5, 3)
        this.pointHelper = new THREE.PointLightHelper(this.pointLight)
        // 
        this.experience.scene.add(this.directionnalLight, this.pointLight, this.ambientLight)
        // this.experience.scene.add(this.pointHelper, this.dirHelper)

    }
    setDebug() {
        const debugObject = {}
        const ui = this.experience.debug.ui
        debugObject.ambientLightColor = "#ffffff"
        debugObject.pointLightColor = "#ffffff"
        debugObject.directionnalLightColor = "#ffffff"
        debugObject.pointLightIntensity = 1.5
        debugObject.directionnalLightIntensity = 0.5
        debugObject.ambientLightIntensity = 1
        // BACKGROUND
        debugObject.BGColor = '#ffffff'
        this.background.material.metalness = 1
        this.background.material.roughness = 0.3
        this.background.material.color.set(debugObject.BGColor)
        ui.addColor(debugObject, 'BGColor').onChange((value) => {
            this.background.material.color.set(value)
        })
        ui.add(this.background.material, 'metalness').min(0).max(1).step(0.01).name('BG Metalness')
        ui.add(this.background.material, 'roughness').min(0).max(1).step(0.01).name('BG Roughness')
        // LIGHTS
        const lightsFolder = ui?.addFolder('Lights').close()

        this.pointLight.color.set(debugObject.pointLightColor)
        this.directionnalLight.color.set(debugObject.directionnalLightColor)
        this.ambientLight.color.set(debugObject.ambientLightColor)
        lightsFolder.add(this.directionnalLight.position, 'x').min(-5).max(5).step(1).name('directionalLight X')
        lightsFolder.add(this.directionnalLight.position, 'y').min(-5).max(5).step(1).name('directionalLight Y')
        lightsFolder.add(this.directionnalLight.position, 'z').min(-5).max(5).step(1).name('directionalLight Z')

        lightsFolder.addColor(debugObject, 'pointLightColor').onChange((value) => {
            this.pointLight.color.set(debugObject.pointLightColor)
        })
        lightsFolder.add(this.pointLight, 'intensity').min(0).max(3).step(0.001).name('pointLight Intensity')
        // 
        lightsFolder.addColor(debugObject, 'directionnalLightColor').onChange((value) => {
            this.directionnalLight.color.set(debugObject.directionnalLightColor)
        })
        lightsFolder.add(this.directionnalLight, 'intensity').min(0).max(3).step(0.001).name('directionnalLight Intensity')

        lightsFolder.add(this.ambientLight, 'intensity').min(0).max(300).step(0.001).name('ambientLight Intensity')
        lightsFolder.addColor(debugObject, 'ambientLightColor').onChange((value) => {
            this.ambientLight.color.set(debugObject.ambientLightColor)
        })

        // MATERIALS
        const materialsFolder = ui?.addFolder('Board Materials')
        debugObject.bordersColors = "#ffffff"
        debugObject.outerRingsColors = "#ffffff"
        debugObject.planeColor = "#ffffff"

        this.borders.material.color.set(debugObject.bordersColors)
        this.outerRings.material.color.set(debugObject.outerRingsColors)
        this.plane.material.color.set(debugObject.planeColor)

        materialsFolder.addColor(debugObject, 'bordersColors').onChange((value) => {
            this.borders.material.color.set(debugObject.bordersColors)
        })
        materialsFolder.addColor(debugObject, 'outerRingsColors').onChange((value) => {
            this.outerRings.material.color.set(debugObject.outerRingsColors)
        })
        materialsFolder.addColor(debugObject, 'planeColor').onChange((value) => {
            this.plane.material.color.set(debugObject.planeColor)
        })



        // rings
        debugObject.ringsZoom = 0.6
        debugObject.ringsLogoColor = '#ffffff'
        debugObject.ringsBGColor = '#555555'
        debugObject.ringsPileColorOne = '#ffffff'
        debugObject.ringsPileColorTwo = '#ffffff'
        this.rings.forEach((ring) => {
            ring.faceMaterial.uniforms.colorTwo.value.set(debugObject.ringsLogoColor)
            ring.faceMaterial.uniforms.colorOne.value.set(debugObject.ringsBGColor)
            ring.pileMaterial.uniforms.colorOne.value.set(debugObject.ringsPileColorOne)
            ring.pileMaterial.uniforms.colorTwo.value.set(debugObject.ringsPileColorTwo)
        })

        const ringsFolder = ui.addFolder('Rings')
        ringsFolder.add(debugObject, 'ringsZoom').min(0).max(3).step(0.1).name('FACE Logo zoom').onChange((value) => {
            this.rings.forEach((ring) => {
                ring.faceMaterial.uniforms.u_zoom.value = value
            })

        })
        ringsFolder.addColor(debugObject, 'ringsLogoColor').onChange((value) => {
            this.rings.forEach((ring) => {
                ring.faceMaterial.uniforms.colorTwo.value.set(debugObject.ringsLogoColor)
            })
        }).name('FACE Logo Color')
        ringsFolder.addColor(debugObject, 'ringsBGColor').onChange((value) => {
            this.rings.forEach((ring) => {
                ring.faceMaterial.uniforms.colorOne.value.set(debugObject.ringsBGColor)
            })
        }).name('FACE BG Color')
        // pile
        ringsFolder.addColor(debugObject, 'ringsPileColorOne').onChange((value) => {
            this.rings.forEach((ring) => {
                ring.pileMaterial.uniforms.colorOne.value.set(debugObject.ringsPileColorOne)
            })
        }).name('PILE Logo Color')
        ringsFolder.addColor(debugObject, 'ringsPileColorTwo').onChange((value) => {
            this.rings.forEach((ring) => {
                ring.pileMaterial.uniforms.colorTwo.value.set(debugObject.ringsPileColorTwo)
            })
        }).name('PILE BG Color')






    }
    setMouse() {
        this.mouse = {
            x: -1,
            y: -1
        }
        // mousemove
        document.addEventListener('pointermove', (e) => {
            this.mouse.x = (e.x - (this.experience.sizes.width / 2)) / (this.experience.sizes.width / 2)
            this.mouse.y = -(e.y - (this.experience.sizes.height / 2)) / (this.experience.sizes.height / 2)
        })
        // click
        window.addEventListener('click', (event) => {
            const shownedRingsCount = this.rings.filter((r) => !r.isHidden)
            // on limite le nombre de ring retournables à 3 max
            this.rings.forEach((ring) => {
                if (ring.isHovered && ring.isHidden && shownedRingsCount.length < 3) {
                    ring.show()
                }
            })

        });
        window.addEventListener('touchstart', (event) => {
            const touch = event.touches[0];

            const simulatedEvent = new PointerEvent('pointermove', {
                clientX: touch.clientX,
                clientY: touch.clientY
            });

            document.dispatchEvent(simulatedEvent);

        });

    }

    resize() {
        this.background.scale.set(Math.tan((this.experience.camera.instance.fov * Math.PI) / 360) * 11 * this.experience.camera.instance.aspect, 1, Math.tan((this.experience.camera.instance.fov * Math.PI) / 360) * 11)

    }
    localReset() {
        this.rings.forEach((r) => r.hide())

    }
    update() {
        const elapsed = this.experience.time.elapsed * 0.001
        if (this.rings.length) {
            this.rings.forEach((r) => {
                r.update()

            })
        }
        const lerpFactor = 0.1; // Ajustez ce facteur pour contrôler la fluidité (0.1 = lent, 0.5 = rapide)
        this.board.rotation.x = THREE.MathUtils.lerp(this.board.rotation.x, -0.1 * this.mouse.y, lerpFactor);
        this.board.rotation.y = THREE.MathUtils.lerp(this.board.rotation.y, 0.1 * this.mouse.x, lerpFactor);

        let cursorState = 'default'
        this.rings.forEach((r) => {
            if (r.isHovered) {
                cursorState = 'pointer'
            }
        });
        document.body.style.cursor = cursorState



    }
}